import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { ACCOUNT_TYPE_PRIVATE, VIEW_ADVERTISER } from '../../../constants'
import { deepClone, deepFreeze } from '../../../utils/object'

export const initialState = deepFreeze({
  token: null,
  isAuthenticated: false,
  view: VIEW_ADVERTISER,
  user: {
    id: 0,
    acceptedPolicyVersion: 0,
    email: '',
    phone: '',
    role: 'user',
    subscribeToNewsletter: false,
    accountType: ACCOUNT_TYPE_PRIVATE,
    rating1Avg: null,
    rating2Avg: null,
    rating3Avg: null,
    ratingCount: 0,
    privateAccount: {
      birthDate: '',
      citizenship: '',
      firstName: '',
      gender: '',
      lastName: '',
      /**
       * Required fields:
       * country
       * county
       * city
       */
      residenceLoc: {
        countryId: null,
        countyId: null,
        cityId: null,
        postalCode: null,
        raw: []
      }
    },
    corporateAccount: {
      companyName: '',
      /**
       * Required fields:
       * country
       * county
       * city
       * streetNumber
       * postalCode
       */
      officeLoc: {
        countryId: null,
        countyId: null,
        cityId: null,
        postalCode: null,
        raw: []
      }
    }
  },
  ratings: {
    given: [],
    received: []
  }
})

let state = deepClone(initialState)

const store = {
  state,
  actions,
  getters,
  mutations
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js